import * as React from "react";
import { forwardRef } from "react";
const CreditCardIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 51 50",
  "data-category": "sources",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  clipPath: "url(#credit-card-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  d: "M45.8125 7.8125H5.1875c-1.72589 0-3.125 1.39911-3.125 3.125v28.125c0 1.7259 1.39911 3.125 3.125 3.125h40.625c1.7259 0 3.125-1.3991 3.125-3.125v-28.125c0-1.72589-1.3991-3.125-3.125-3.125"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#114A7B",
  d: "M2.0625 17.1875h46.875"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  d: "M11.4375 26.5625H28.625"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#114A7B",
  d: "M11.4375 32.8125H22.375"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "credit-card-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h50v50H.5z"
}))));
const ForwardRef = forwardRef(CreditCardIcon);
ForwardRef.category = "sources";
export { ForwardRef as CreditCardIcon };